import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle = ({ size }) => {
  const { language, toggleLanguage } = useLanguage();
  const sm = size === 'sm';
  const track = sm ? 'w-12 h-6' : 'w-16 h-8';
  const knob = sm ? 'w-6 h-6' : 'w-8 h-8';
  const shift = sm ? 'translate-x-6' : 'translate-x-8';
  const flag = sm ? 'w-4 h-4' : 'w-5 h-5';

  return (
    <div className="relative">
      <button
        onClick={toggleLanguage}
        className={`relative ${track} bg-gray-200 rounded-full transition-colors duration-300 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 overflow-hidden`}
      >
        {/* Half-width sliding toggle */}
        <div
          className={`absolute inset-0 bg-white ${knob} rounded-full transition-transform duration-300 z-10 ${
            language === 'en' ? shift : 'translate-x-0'
          }`}
        >
          <div className="w-full h-full flex items-center justify-center">
            <img
              src={`/${language === 'th' ? 'thailand' : 'united-states'}.png`}
              alt={`${language === 'th' ? 'Thai' : 'English'} flag`}
              className={`${flag} rounded-full object-cover`}
            />
          </div>
        </div>

        {/* Background Flags */}
        <div className="absolute inset-0 flex items-center justify-between px-1">
          <img
            src="/thailand.png"
            alt="Thai flag"
            className={`${flag} rounded-full object-cover`}
          />
          <img
            src="/united-states.png"
            alt="US flag"
            className={`${flag} rounded-full object-cover`}
          />
        </div>
      </button>
    </div>
  );
};

export default LanguageToggle; 